import { render, staticRenderFns } from "./UpcomingTrips.vue?vue&type=template&id=1e0c9e10&"
import script from "./UpcomingTrips.vue?vue&type=script&setup=true&lang=js&"
export * from "./UpcomingTrips.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports